import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {
    Tabs,
    Tab,
    Divider,
    colors
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(2)
    },
    divider: {
        backgroundColor: colors.grey[300]
    },
}));

let NavTabs = ({onClick, tabsProps, tabs, tab, className}) => {
    const classes = useStyles();

    return (
        <div className={classNames(classes.root, className)}>
            <Tabs
                value={tab}
                onChange={onClick}
                indicatorColor="primary"
                scrollButtons="auto"
                variant="scrollable"
                {...tabsProps}
            >
                {tabs.map(t => <Tab key={t.value} label={t.label} value={t.value} {...t} />)}
            </Tabs>
            <Divider className={classes.divider}/>
        </div>
    )
}

NavTabs.propTypes = {
    // from parent
    onClick: PropTypes.func.isRequired,
    tabsProps: PropTypes.object,
    appbarProps: PropTypes.object,
    tabs: PropTypes.array.isRequired,
    tab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
}

export {NavTabs}
export default NavTabs
